var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgXCirclePurple = function SvgXCirclePurple(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#A897F4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.756 0C3.928 0 0 3.928 0 8.757c0 4.827 3.928 8.756 8.756 8.756s8.756-3.929 8.756-8.756C17.512 3.928 13.584 0 8.756 0z",
    transform: "translate(-298.000000, -617.000000) translate(298.000000, 617.000000)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#5743AF",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M5.5 8.5L12.5 8.5",
    transform: "translate(-298.000000, -617.000000) translate(298.000000, 617.000000)"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXCirclePurple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/X_circle_purple.3fe1c36c.svg";
export { ForwardRef as ReactComponent };